import { render, staticRenderFns } from "./RegistrationSummaryComponent.vue?vue&type=template&id=282fa8c7&lang=pug&"
import script from "./RegistrationSummaryComponent.vue?vue&type=script&lang=ts&"
export * from "./RegistrationSummaryComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports